import Axios from "../redux/setupAxios";
import { Urls } from "../app/utils/constants";
import { microserviceNames } from "../app/utils/constants";

const proxyName = microserviceNames.stakeholderMicroserviceWithoutToken;

export async function getCriteriaQuestionsByIndustrySubCategory(industrySubCategory) {
    return (await Axios.get(`${proxyName}/${Urls.CriteriaQuestions}/filter?category=${industrySubCategory}`)).data;
}